import React from 'react'
import Translation from '../General/Translation'

const ProductionCountry = ({productionCountry, translation}) => {
    if (productionCountry === '' || !productionCountry) {
        return ''
    } else {
        return (
            <p className="text-light production-country"><span className="typo-color-muted"><Translation id="productionCountry" trans={translation}>Produktionsland</Translation>: </span> {productionCountry}</p>
        )
    }
}


export default ProductionCountry